export const checkIsHomologEnvironment = (hostname: string | undefined, envName: string | undefined): boolean => {
  if (typeof hostname === 'string' && hostname.includes('.hml.')) {
    return true
  }

  return envName === 'homol'
}
